export enum SocialSeriesMetricsEnum {
    NETWORK_VOLUME = 'network_volume',
    NETWORK_IMPRESSIONS = 'network_impressions',
    NETWORK_ENGAGEMENTS = 'network_engagements',
    VOLUME = 'volume',
    IMPRESSIONS = 'impressions', // audience_reach
    ENGAGEMENTS = 'engagements',
    POSITIVE_VOLUME = 'positive_volume',
    NEGATIVE_VOLUME = 'negative_volume',
    ENGAGEMENTS_PER_POST = 'engagements_per_post',
    ENGAGEMENT_RATE = 'engagement_rate',
    LIKES = 'likes', // Applause
    QUOTES = 'quotes',
    REPLIES = 'replies',
    RETWEETS = 'retweets',
    COMMENTS = 'comments',

    APPLAUSE = 'APPLAUSE',
    AMPLIFICATION = 'AMPLIFICATION',
    SHARES = 'shares', // Amplification
    VIEWS = 'views',
    CONVERSATION = 'conversation', // Replies & Quotes -> aka sortFunction

    AVE = 'ave',
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    NEUTRAL = 'neutral',

    AVERAGE_DOMAIN_AUTHORITY = 'average_domain_authority'
}
